export default __webpack_public_path__ + "static/alpaca-slider-first-image-d16705fab6ac4263fbad310e0d759919.jpg";